<template>
  <div>
    <loader v-if="!loaded"></loader>

    <div class="modal-open">
      <div class="modal modal-opened modal-login" tabindex="-1" role="dialog" aria-hidden="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content modal-rounded">
            <div class="row">
              <div class="col-md-12">
                <form enctype="multipart/form-data" novalidate>
                  <div class="modal-header">
                    <h2 class="modal-title">{{'login.labels.login' | trans}}</h2>
                  </div>
                  <div class="modal-body">

                    <div class="alert alert-danger" role="alert"
                         v-if="errors.has('server')">
                      {{errors.first('server')}}
                    </div>

                    <div class="form-group row">
                      <div class="col-md-12">

                        <mdc-textfield v-model="user.username"
                                       :label="'validation.attributes.username' | trans" type="text"
                                       name="username"
                                       :class="{'is-invalid': errors.has('username')}"
                                       v-validate="'required|max:255|min:5'"
                                       data-vv-validate-on="none"
                                       :data-vv-as="'validation.attributes.username' | trans"/>

                        <span class="invalid-feedback" v-if="errors.has('username')">{{ errors.first('username') }}</span>

                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <mdc-textfield v-model="user.password"
                                       :label="'validation.attributes.password' | trans"
                                       type="password" name="password"
                                       :class="{'is-invalid': errors.has('password')}"
                                       v-validate="'required|min:8|max:16'" data-vv-validate-on="none"
                                       :data-vv-as="'validation.attributes.password' | trans"/>
                        <small class="form-text text-muted">{{'passwords.password_subscription' | trans}}</small>

                        <span class="invalid-feedback" v-if="errors.has('password')">
                            {{ errors.first('password') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-success active text-uppercase btn-signup float-right" @click.prevent="login()"
                            :disabled="disabled">
                      {{'login.buttons.login' | trans}}
                    </button>
                    <router-link class="btn btn-link success-link mr-2"
                                 :to="{name: 'password-recovery-send-token'}">{{'login.labels.forgot' |
                      trans}}
                    </router-link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import isObject from 'lodash/isObject';
  import {Validator} from 'vee-validate';
  import lang from '../../../lang/translator';
  import Auth from '../../../common/auth/Manager';
  import {mapGetters} from 'vuex';
  import Loader from '../../../modules/loader/components/Loader';

  export default {
    components: {Loader},
    data() {
      return {
        user: {
          username: null,
          password: null,
        },
        disabled: false,
        loaded: true
      };
    },
    metaInfo: {
      title: lang.get('login.labels.login'),
    },
    computed: {
      ...mapGetters('auth', [
        'isClient'
      ])
    },
    methods: {
      login: async function () {
        this.disabled = true;
        this.loaded = false;
        this.errors.clear();
        let result = await this.$validator.validateAll();
        if (!result) {
          this.loaded = true;
          this.disabled = false;
          return;
        }
        try {
          let isSaved = await Auth.login(this.user.username, this.user.password);
          this.isClient ?  this.$router.push({name: 'available-protocols'}) :  this.$router.push({name: 'client'})
        } catch ({response}) {
          let errors = response.data.errors;
          if (isObject(errors)) {
            if (errors.message) {
              this.errors.add('server', errors.message);
            } else {
              for (let key of Object.keys(errors)) {
                let {message} = errors[key].message ? errors[key] : errors[key][0];
                this.errors.add(key, message);
              }
            }
          }

          this.disabled = false;
        } finally {
          this.loaded = true;
        }
      },

    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/login/components/LoginForm.vue